export enum CompareScreens {
  Landing = 'landing',
  Metrics = 'metrics',
  Groups = 'groups',
  Retailers = 'retailers'
}
